import React, {useEffect, useRef} from "react";
import RenderChildren from "./RenderChildren";
import Autosizer from "react-virtualized-auto-sizer";
import {VariableSizeGrid as Grid} from "react-window";
import PropTypes from "prop-types";
import InfiniteLoader from "react-window-infinite-loader";
import {usePaginatedData} from "./usePaginatedData";

const VirtualForEach = (props) => {
    const {
        adaptiveWidth, arrayToRender = [], containerArrayPath, creatable, removable, path, children,
        actionsContext, styles, list
    } = props;
    const infiniteLoaderRef = useRef(null)
    const listRef = useRef({});
    const rowHeights = useRef({});
    const cols = (100 / adaptiveWidth.replace(/[^0-9\.]+/g, '')).toFixed();
    const [content, dataLength, hasMore, loadMore] = usePaginatedData(list)

    function getRowHeight(index) {
        return rowHeights.current[index];
    }

    function setRowHeight(index, size) {
        listRef.current.resetAfterIndices({
            columnIndex: 0,
            rowIndex: 0,
            shouldForceUpdate: true
        });
        // listRef.current.resetAfterColumnIndex({columnIndex:0})
        rowHeights.current = {...rowHeights.current, [index]: size};
    }

    function Row({rowIndex, columnIndex, style}) {
        const rowRef = useRef({});
        const valueIndex = rowIndex * cols + columnIndex;
        const value = list ? content[valueIndex] : arrayToRender[valueIndex];
        useEffect(() => {
            if (rowRef.current) {
                setRowHeight(valueIndex, rowRef.current.clientHeight);
            }
        }, [rowRef]);
        if (!value) return <></>
        return (
            <div style={{...style, padding: (creatable || removable) && '2px 0 2px 15px'}} ref={rowRef}>
                <RenderChildren
                    path={containerArrayPath ? `${containerArrayPath}.${path}` : path}
                    children={children}
                    value={value}
                    valueIndex={valueIndex}
                />
            </div>
        )
    }

    if (actionsContext.isVisibleTab === false) return <></>
    return (
        <div style={{padding: 20, height: '98%', width: '100%'}}>
            <Autosizer>
                {({height, width}) => (
                    <InfiniteLoader
                        ref={infiniteLoaderRef}
                        isItemLoaded={true}
                        itemCount={list ? hasMore ? dataLength.length + 1 : dataLength : arrayToRender.length}
                        loadMoreItems={loadMore}
                    >
                        {({onItemsRendered, ref}) => (
                            <Grid
                                columnCount={cols}
                                columnWidth={() => width / cols}
                                height={height}
                                rowCount={(list ? dataLength : arrayToRender.length / cols).toFixed()}
                                overscanRowCount={20}
                                rowHeight={index => getRowHeight(index)}
                                width={width + 5}
                                style={{margin: -4}}
                                ref={listRef}
                            >
                                {Row}
                            </Grid>
                        )}
                    </InfiniteLoader>
                )}
            </Autosizer>
        </div>
    )
}
export default VirtualForEach
VirtualForEach.propTypes = {
    adaptiveWidth: PropTypes.string,
    arrayToRender: PropTypes.array,
    containerArrayPath: PropTypes.string,
    creatable: PropTypes.bool,
    removable: PropTypes.bool,
    path: PropTypes.string,
    children: PropTypes.object,
    actionsContext: PropTypes.object
}